import React, { Component, PropTypes } from 'react';

import { supportsVideoAutoPlay } from '../../util';

import './LoadingModal.css';

export default class LoadingModal extends Component {
    static propTypes = {
        graphic: PropTypes.string.isRequired,
        message: PropTypes.string,
    }

    render() {
        const { graphic, message } = this.props;
        const autoplayEnabled = supportsVideoAutoPlay();
        const display = message ? `block` : `none`;

        const graphicJsx = autoplayEnabled ?
            <video muted autoPlay playsInline loop>
                <source src={`/images/${graphic}@2x.mp4`} type="video/mp4" />
            </video> : <div className={`video-fallback ${graphic}`}></div>;

        return (
            <div className="modal-wrapper" style={{ display }}>
                <div className="loading-modal modal">
                    <div className="video-wrapper">
                        <h1>{message}</h1>
                        {graphicJsx}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/LoadingModal.jsx